export default "__VITE_ASSET__CDzCQoNa__"